export default {
  transaction: {
    title: '取引履歴',
    select: '選択',
    all: 'すべて',
    loading: '読み込み中...',
    noMoreData: 'これ以上のデータはありません',
    mockSuccess: '模擬成功',
    mockFail: '模擬失敗',
    mockSuccessDone: '模擬成功が完了しました',
    mockFailDone: '模擬失敗が完了しました',
    mockFailed: '模擬に失敗しました',
    today: '今日',
    yesterday: '昨日',
    last3Days: '過去3日間',
    last7Days: '過去7日間',
    last15Days: '過去15日間',
    last30Days: '過去30日間',
    allTypes: 'すべての種類',
    deposit: '入金',
    withdrawal: '出金',
    withdrawalRefund: '出金返金',
    bet: 'ベット',
    win: '勝利',
    manualAdd: '手動追加',
    manualSubtract: '手動減算',
    commission: 'コミッション',
    bonus: 'ボーナス',
    vipUpgradeReward: 'VIP昇格報酬',
    vipSalary: 'VIP給与',
    gameOutPrincipal: 'ゲーム出金 - 元本',
    gameOutBonus: 'ゲーム出金 - ボーナス',
    bonusTransferOut: 'ボーナス振替出金',
    allStats: 'すべてのステータス',
    underReview: '審査中',
    pendingPayout: '出金待ち',
    successful: '成功',
    failed: '失敗',
    cancelled: 'キャンセル済み',
    processing: '処理中',
  },
};
